export default function genererTourneeModele() {
  return {
    tourneeLignes: [],
    afficheur: null,
    societeId: null,
    afficheurId: null,
    libelle: null,
    jourDepart: 1,
    actif: true,
    agenceId: null,
  };
}
